"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsLoginSettings = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DmsForm = require("../DmsForm/DmsForm");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsTextField = require("../DmsTextField/DmsTextField");
var _DmsSelect = require("../DmsSelect/DmsSelect");
var _PasswordRegexDescription = require("../../constants/PasswordRegexDescription");
var _DmsTokenHook = require("../DmsTokenHook/DmsTokenHook");
var _material = require("@mui/material");
var _useGet = require("../../Hooks/useGet");
var _dist = require("../../../dist");
var _DmsSwitch = require("../DmsSwitch/DmsSwitch");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @Author: Alexander Silva Barbosa
 * @Date:   2023-02-01 14:55:19
 * @Last Modified by:   Fernando Schneider
 * @Last Modified time: 2024-05-02 11:33:37
 */
const DmsLoginSettings = () => {
  var _loginSettingsData$ma, _loginSettingsData$pa, _loginSettingsData$pa2, _loginSettingsData$to, _loginSettingsData$in, _loginSettingsData$pa3, _loginSettingsData$ma2;
  const token = (0, _DmsTokenHook.getToken)();
  const {
    data,
    isLoading
  } = (0, _useGet.useGet)('/login_settings', null, true);
  const [loginSettingsData, setLoginSettingData] = (0, _react.useState)(null);
  const passwordFormatOptions = Object.keys(_PasswordRegexDescription.PasswordRegexDescription).map(key => ({
    label: key,
    value: _PasswordRegexDescription.PasswordRegexDescription[key]
  }));
  (0, _react.useEffect)(() => {
    if (data) {
      setLoginSettingData(data.data);
    }
  }, [data]);
  const handleChange = (name, value) => {
    setLoginSettingData(prevData => _objectSpread(_objectSpread({}, prevData), {}, {
      [name]: value
    }));
  };
  if (isLoading || !loginSettingsData) {
    return /*#__PURE__*/_react.default.createElement(_dist.DmsLoading, null);
  }
  return /*#__PURE__*/_react.default.createElement(_DmsForm.DmsForm, {
    url: '/login_settings',
    method: "PUT",
    token: token,
    fieldTypes: {
      max_qt_tries: 'int',
      password_expiration: 'int',
      password_expiration_notify: 'int',
      token_expiration: 'float',
      inactivity_time: 'float',
      password_format_pk: 'int',
      max_user_tokens: 'int',
      finger_printer_login: 'bool',
      authenticator_pk: 'int'
    }
  }, /*#__PURE__*/_react.default.createElement(_DmsForm.DmsForm.Body, null, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsTextField.DmsTextField, {
    name: "max_qt_tries",
    label: _reactIntlUniversal.default.get("Maxqttries").d("Limit of login attempts")
    // xs={12} sm={6} md={6} lg={6}
    ,
    fullWidth: true,
    value: (_loginSettingsData$ma = loginSettingsData.max_qt_tries) !== null && _loginSettingsData$ma !== void 0 ? _loginSettingsData$ma : "",
    onChange: e => handleChange("max_qt_tries", e.target.value)
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsTextField.DmsTextField, {
    name: "password_expiration",
    label: _reactIntlUniversal.default.get("Passwordexpiration").d("Password expiration in days"),
    fullWidth: true,
    value: (_loginSettingsData$pa = loginSettingsData.password_expiration) !== null && _loginSettingsData$pa !== void 0 ? _loginSettingsData$pa : "",
    onChange: e => handleChange("password_expiration", e.target.value)
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsTextField.DmsTextField, {
    name: "password_expiration_notify",
    label: _reactIntlUniversal.default.get("PasswordExpirationNotify").d("Number of days to notify user before password expires"),
    fullWidth: true,
    value: (_loginSettingsData$pa2 = loginSettingsData.password_expiration_notify) !== null && _loginSettingsData$pa2 !== void 0 ? _loginSettingsData$pa2 : "",
    onChange: e => handleChange("password_expiration_notify", e.target.value)
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsTextField.DmsTextField, {
    name: "token_expiration",
    label: _reactIntlUniversal.default.get("TokenExpirationTimeseconds").d("Token Expiration Time (seconds)"),
    fullWidth: true,
    value: (_loginSettingsData$to = loginSettingsData.token_expiration) !== null && _loginSettingsData$to !== void 0 ? _loginSettingsData$to : "",
    onChange: e => handleChange("token_expiration", e.target.value)
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsTextField.DmsTextField, {
    name: "inactivity_time",
    label: _reactIntlUniversal.default.get("InactivityTimeseconds").d("Inactivity Time (seconds)"),
    fullWidth: true,
    value: (_loginSettingsData$in = loginSettingsData.inactivity_time) !== null && _loginSettingsData$in !== void 0 ? _loginSettingsData$in : "",
    onChange: e => handleChange("inactivity_time", e.target.value)
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsSelect.DmsSelect, {
    name: "password_format_pk",
    label: _reactIntlUniversal.default.get("PasswordFormats").d("Password Formats"),
    options: passwordFormatOptions // Use label and value from PasswordRegexDescription
    ,
    fullWidth: true,
    value: (_loginSettingsData$pa3 = loginSettingsData.password_format_pk) !== null && _loginSettingsData$pa3 !== void 0 ? _loginSettingsData$pa3 : "" // Numeric value
    ,
    onChange: value => handleChange("password_format_pk", value) // Pass numeric value directly
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsTextField.DmsTextField, {
    name: "max_user_tokens",
    label: _reactIntlUniversal.default.get("MaxTokensPerUser").d("Max Tokens per User"),
    fullWidth: true,
    value: (_loginSettingsData$ma2 = loginSettingsData.max_user_tokens) !== null && _loginSettingsData$ma2 !== void 0 ? _loginSettingsData$ma2 : "",
    onChange: e => handleChange("max_user_tokens", e.target.value)
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsSwitch.DmsSwitch, {
    name: "finger_printer_login",
    label: _reactIntlUniversal.default.get("FingerPrinterLogin").d("Finger printer login"),
    checked: loginSettingsData.finger_printer_login || false,
    onChange: value => handleChange("finger_printer_login", value)
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsSelect.DmsSelect, {
    name: "authenticator_pk",
    label: _reactIntlUniversal.default.get("Authenticator").d("Authenticator"),
    url: "/authenticators/all",
    value: loginSettingsData.authenticator_pk,
    onChange: value => handleChange("authenticator_pk", value)
  })))));
};
exports.DmsLoginSettings = DmsLoginSettings;